<form (ngSubmit)="upload()" [formGroup]="form">
    <div class="file-upload">
        @let files = files$ | async;
        @if (files && files.length > 0) {
            <div class="file-upload-inner">
                <app-document-filename [filename]="files[0].name"/>
                @if (files.length > 1) {
                    <span>(+{{ files.length - 1 }} {{ 'IMPORT.FILES' | translate }})</span>
                }
            </div>
        } @else {
            <div data-qa="upload-files-template">
                <div (click)="fileUpload.click()" (dropped)="addFiles($event.files)" appDropImport class="file-upload-inner file-upload-inner-with-input" data-qa="drop-files-or-browse">
                    {{ 'IMPORT.DROP_FILES_HERE' | translate }}
                </div>
                <input #fileUpload (change)="uploadFiles($event)" data-qa="upload-files-input" multiple type="file"/>
            </div>
        }
    </div>
    <div class="settings" data-qa="import-settings">
        <div class="headline">{{ 'IMPORT.IMPORT_LOCATION'|translate }}</div>
        <div class="import-location" data-qa="import-location">
            <div class="vault">
                <label for="import-location-input">{{ 'VAULT' | translate }}</label>
                <app-autocomplete-input [hasClearButton]="true" [maxVisibleItems]="5" [minCharsToOpen]="3"
                                        [prefixIconFallback]="ICONS.VAULT"
                                        [prefixIconUrl]="(selectedVaultIconUrl()|apiVaultIconUrl) ?? ''"
                                        [suggestions]="autocompleteVaults()"
                                        data-qa="import-vault-check-input"
                                        formControlName="vault"
                                        id="import-location-input"/>
            </div>
            <div class="target">
                <label id="import-target-label">{{ 'IMPORT.STORAGE_LOCATION' | translate }}</label>
                <app-select [options]="selectOptionsImportLocations()" ariaLabelledBy="import-target-label" class="import-select-field" formControlName="target"
                            name="import-target-check-input" qaTag="import-target-check-input"/>
            </div>
        </div>
        <div class="headline headline-collision">{{ 'IMPORT.COLLISION_SETTINGS'|translate }}</div>
        <div class="collision" data-qa="import-file-collision-detection">
            <div class="same-file-detection" data-qa="import-same-file-detected">
                <label id="import-same-file-detected-label">{{ 'IMPORT.SAME_FILE_DETECTED' | translate }}</label>
                <app-select [options]="selectOptionsSameFileSettings()" ariaLabelledBy="import-same-file-detected-label" class="import-select-field"
                            formControlName="sameFileDetected"
                            name="import-same-file-detected-form-control" qaTag="import-same-file-detected-form-control"/>
            </div>
        </div>
    </div>
</form>
